import {Api} from "@/repository/api";

export class AssignmentRepository extends Api {
    constructor() {
        super("assignments");
    }

}